import manifest from '@shared/permissions.json'

/** @type {Record<string, string>} */
export const PERMISSIONS = Object.fromEntries(
  manifest.permissions.map((permission) => [permission.key, permission.slug]),
)

/** @type {typeof manifest.permissions} */
export const PERMISSION_DEFINITIONS = manifest.permissions

/**
 * @param {import('@/types/api').AuthUser | null | undefined} user
 * @param {string} permission
 */
export function hasPermission(user, permission) {
  const permissions = user?.permissions ?? []
  if (permissions.includes(PERMISSIONS.ADMIN_FULL)) {
    return true
  }
  return permissions.includes(permission)
}

/**
 * @param {import('@/types/api').AuthUser | null | undefined} user
 * @param {string[]} requiredPermissions
 */
export function hasAnyPermission(user, requiredPermissions) {
  return requiredPermissions.some((permission) => hasPermission(user, permission))
}
